import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import Typography from "../../../Typography";
import UserPhoto from "../../../UserPhoto/userphoto";
import Audio from "../../../Audio/Audio";
import Loading from "../../../Loading";

import { ReactComponent as IconDownload } from "../../../../build/images/image-modal/Document-download.svg";

const { connection_platform } = require("../../../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}
function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

export default function DetailsVoiceModal({ infosContact }) {
  const InfoUsers = useSelector((state) => state.informationusers);
  const History = useSelector((state) => state.history);

  const handleAudio = () => {
    const audioButton = document.getElementsByClassName(
      "rhap_play-pause-button",
    );
    const stateAudio = audioButton[0].getAttribute("aria-label");

    if (stateAudio === "Pause") {
      audioButton[0].click();
    }
    // console.log("Oq vem", audioButton[0].getAttribute("aria-label"));
  };

  const memoizedHistory = useMemo(() => {
    if (History.length > 0) {
      return History;
    }

    return [];
  }, [History]);

  return (
    <div
      className="modal micromodal-slide"
      id="modal__interacao-voz"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__interacao-voz__title"
        >
          <header className="modal__header">
            <Typography.H2 color={"blue-selected-4"} weight={700}>
              Histórico de atendimento
            </Typography.H2>
            <button
              className="modal__close"
              aria-label="Close modal"
              onClick={handleAudio}
              data-micromodal-close
            ></button>
          </header>
          <main className="modal__content" id="modal__interacao-voz__content">
            <div className="interacoes-info">
              <div className="interacoes-info__name">
                <UserPhoto size="large" />
                <div className="interacoes-info__call-info__phone">
                  <Typography.H4 color={"black"}>
                    {createJSON(infosContact.nome)}
                  </Typography.H4>
                  <Typography.H5 color={"gray-180"}>
                    {infosContact.telefone}
                  </Typography.H5>
                </div>
              </div>
              <div className="interacoes-info__call-info">
                <div className="interacoes-info__call-info__date">
                  Atendimento - {infosContact.data}
                </div>
              </div>
            </div>
            <div className="interacoes-media-content">
              <div className="bubble">
                {memoizedHistory.length > 0 ? (
                  memoizedHistory.map((history) =>
                    (() => {
                      if (InfoUsers.permreproduce === true) {
                        return (
                          <div className="bubble-media">
                            {(() => {
                              var url = history.messagem;
                              var name = "Sem arquivo de áudio disponível";
                              let format = "";
                              if (url) {
                                url = url.replace(
                                  "192.168.178.2",
                                  "\\" + history.particao,
                                );
                                var name = url.split("\\");
                                name = name.pop();
                                format = name.split(".")[1];
                              }

                              return (
                                <>
                                  <div
                                    className="bubble-media__playerBar"
                                    style={{ height: "62px" }}
                                  >
                                    <Audio
                                      audio
                                      link={
                                        InfoUsers.permreproduce
                                          ? connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            url
                                          : ""
                                      }
                                      showImg={true}
                                    />
                                  </div>
                                  <div className="bubble-media__mediaInfo">
                                    <span className="bubble-media__fileName">
                                      <p className="bubble-media__text">
                                        {name}
                                      </p>
                                      <br />
                                      <div className="fileinfo__bar">
                                        <span className="fileinfo__size">
                                          FORMATO
                                        </span>{" "}
                                        •{" "}
                                        <span className="fileinfo__type">
                                          {format
                                            ? format.toLocaleUpperCase()
                                            : ""}
                                        </span>
                                      </div>
                                    </span>
                                    {(() => {
                                      if (
                                        InfoUsers.permdownload === true &&
                                        url
                                      ) {
                                        return (
                                          <span className="bubble-media__newdownload">
                                            <a
                                              href={
                                                connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                url
                                              }
                                              target="_blank"
                                              download
                                              className="bubble-media__btnDownload"
                                            >
                                              {/* <i className="material-icons">
                                                        get_app
                                                      </i> */}
                                              <IconDownload />
                                            </a>
                                          </span>
                                        );
                                      }
                                    })()}
                                  </div>
                                  <div className="bubble-media__progressbar-wrapper">
                                    <div className="bubble-media__progressbar-track">
                                      <div
                                        className="bubble-media__progressbar-bullet"
                                        style={{ width: "17%" }}
                                      ></div>
                                    </div>
                                    <span className="bubble-media__progressbar-counter ">
                                      17%
                                    </span>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        );
                      }
                    })(),
                  )
                ) : (
                  <Loading.Paperplane fullPage={true} />
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
